import React from "react";
// import Select from "react-select";
import { useNavigate } from "react-router-dom";

function AddReturnForm() {
  const navigate = useNavigate();
  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex justify-between items-center mb-4">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-[#7B20C7] text-2xl">Add Item</h1>
          </div>
        </div>
        <div className="w-full">
          <form
            action=""
            className="w-full"
            onSubmit={(e) => e.preventDefault()}
          >
            <div className="flex flex-col lg:flex-row gap-x-8 gap-y-2 w-full">
              <label htmlFor="" className="w-full lg:w-1/2">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  Reference No
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder="Reference No"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>
              <label htmlFor="" className="w-full lg:w-1/2">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  Date
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder=" 2024-01-20 01:34:35 "
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>
            </div>

            <div className="flex flex-col lg:flex-row gap-x-8 gap-y-2 w-full pt-5">
              <label htmlFor="" className="w-full lg:w-1/7 ">
                <h1>SN</h1>
              </label>

              <label htmlFor="" className="w-full lg:w-1/7 ">
                <h1>Name</h1>
              </label>

              <label htmlFor="" className="w-full lg:w-1/7">
                <span className="">Unit Price</span>
              </label>

              <label htmlFor="" className="w-full lg:w-1/7">
                <span className="">Vat</span>
              </label>

              <label htmlFor="" className="w-full lg:w-1/7">
                <span className=""> Quantity</span>
              </label>

              <label htmlFor="" className="w-full lg:w-1/7">
                <span className="">Total</span>
              </label>

              <label htmlFor="" className="w-full lg:w-1/7">
                <span className="">Actions</span>
              </label>
            </div>

            <div className="flex flex-col lg:flex-row gap-x-8 gap-y-2 w-full pt-3">
              <label htmlFor="" className="w-full lg:w-2/4">
                <span className="text-[#7B20C7] text-sm mb-2 relative ">
                  Note
                </span>
                <div className="mb-2 pt-0">
                  <textarea rows="3"
                    type="text"
                    placeholder="Enter..."
                    className="px-2 py-4 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>
              <label htmlFor="" className="w-full lg:w-1/4"></label>

              <label htmlFor="" className="w-full lg:w-1/4">
                <span className="text-[#7B20C7] text-sm mb-2 relative ">
                  Grand Total
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder="Grand Total"
                    className="px-2 py-4 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>
            </div>

            <span className="w-full bg-[#7B20C7] h-1 my-2 inline-block"></span>
            <div className="flex gap-2">
              <button
                className="bg-[#7B20C7] text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                type="submit"
              >
                Submit
              </button>
              <button
                className="bg-[#7B20C7] text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                type="button"
                onClick={() => navigate(-1)}
              >
                Back
              </button>
            </div>
          </form>
        </div>
      </div>
    </main>
  );
}

export default AddReturnForm;
